import React from "react";
import "./portfolio.css";
import { portfolioData } from "./data";

function Portfolio() {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio_container">
        {portfolioData.map((item) => (
          <article className="portfolio_item" key={item.id}>
            <a
              href={item.demo}
              className="portfolio_item-image"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={item.image} alt={item.title} />
            </a>
            <h3>{item.title}</h3>
            <small>{item.description}</small>
            <div className="portfolio_item-cta">
              {item.github && (
                <a
                  href={item.github}
                  className="btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
              )}
              <a
                href={item.demo}
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.cta || "Live Demo"}
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Portfolio;
